import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import CustomBreadcrumb from '../../components/base/CustomBreadcrumb';
import BaseForm from '../../components/base/v2/BaseForm';
import AppUpdateStepOne from 'components/maintenance/AppUpdateStepOne';


const AppUpdateDetail = ({
  appUpdateDetail,
  hasUpdatedDefaultValues,
  formHasSubmitted,
}) => {
  const dispatch = useDispatch();
  const [completeProcess, setShowCompleteProcess] = useState(false);

  useEffect(() => {
    dispatch({
      type: 'appUpdate/getAppUpdate',
      payload: {}
    });
  }, [dispatch]);

  const reset = () => {
    setShowCompleteProcess(false);
    dispatch({
      type: 'appUpdate/resetStatus',
      payload: {}
    });
  };

  const stepContent = [
    <AppUpdateStepOne
      setShowCompleteProcess={setShowCompleteProcess}
    />,
  ];

  return (
    <>
      <BaseForm
        defaultValues={appUpdateDetail}
        hasUpdatedDefaultValues={hasUpdatedDefaultValues}
        formHasSubmitted={formHasSubmitted}
        tempSave={() => { }}
        stepsConfig={null}
        content={stepContent}
        currentStep={0}
        breadcrumb={
          <CustomBreadcrumb name="App Update" />
        }
        caution={{
          title: 'App Update',
          detail: 'Inform customers about latest release of app.\n\nIf latest version is 0.5 and lowest supporting version is 0.3\n0.1 - 0.2 will see force update notice\n0.3 to 0.4 will see optional update notice\n0.5 will not see any notice',
        }}
        showFinishPop={completeProcess}
        nextStepConfig={{
          title: 'Successfully Saved!',
          description: '',
          steps: null,
          onHide: reset,
          buttons: [
            {
              text: 'Done',
              action: reset,
            },
          ],
        }}
        hasUnSavePrompt={false}
        hasCancelButton
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  appUpdateDetail: state.appUpdate.appUpdateDetail,
  hasUpdatedDefaultValues: state.appUpdate.hasUpdatedDefaultValues,
  formHasSubmitted: state.appUpdate.formHasSubmitted,
});

export default connect(mapPropsToState)(AppUpdateDetail);
